import { CurrencyPipe } from '@angular/common'
import { Component, inject, Input } from '@angular/core'
import { PriceTypeEnum } from '@app/core/models/custom/price.model'
import { Price, PriceRange, Product } from '@spartacus/core'

@Component({
  selector: 'ccg-product-grid-price',
  templateUrl: './product-grid-price.component.html',
  styleUrl: './product-grid-price.component.scss',
  providers: [CurrencyPipe],
  standalone: false
})
export class ProductGridPriceComponent {
  private readonly currencyPipe = inject(CurrencyPipe)
  price: string = ''
  msrp: string = ''

  private _product: Product | undefined

  @Input()
  set product (productToSet: Product) {
    if (this._product !== productToSet) {
      this._product = productToSet
      this.initializePrices()
    }
  }

  get product (): Product | undefined {
    return this._product
  }

  private initializePrices () {
    this.price = ''
    this.msrp = ''

    if (this._product) {
      this.setValuesForPrices()
    }
  }

  setValuesForPrices () {
    if (this.product) {
      if (this.existAndHasValues(this.product?.priceRange)) {
        this.setPrice(this.product.priceRange, PriceTypeEnum.priceRange)
      } else if (this.existAndHasValues(this.product.price)) {
        this.setPrice(this.product.price, PriceTypeEnum.price)
      }
      if (this.existAndHasValues(this.product.msrpRange)) {
        this.setPrice(this.product.msrpRange, PriceTypeEnum.msrpRange)
      } else if (this.existAndHasValues(this.product.msrp)) {
        this.setPrice(this.product.msrp, PriceTypeEnum.msrp)
      }

      if (this.msrp && this.price) {
        if (
          this.product.priceRange?.maxPrice?.value === this.product.msrpRange?.maxPrice?.value && this.product.priceRange?.minPrice?.value === this.product.msrpRange?.minPrice?.value
        ) {
          this.msrp = ''
        }
      }
    }
  }

  setPrice (price: PriceRange | Price, priceType: PriceTypeEnum) {
    let priceToSet: string
    if (priceType === PriceTypeEnum.msrpRange || priceType === PriceTypeEnum.priceRange) {
      priceToSet = this.convertPriceRangeToString(price as PriceRange)
    } else {
      priceToSet = this.convertPriceToString(price as Price)
    }
    if (priceType === PriceTypeEnum.msrpRange || priceType === PriceTypeEnum.msrp) {
      this.msrp = priceToSet
    } else {
      this.price = priceToSet
    }
  }

  convertPriceRangeToString (priceRange: PriceRange): string {
    let priceString = ''
    if (priceRange.minPrice && priceRange.maxPrice && priceRange.minPrice.value !== priceRange.maxPrice.value) {
      priceString = `${this.convertPriceToString(priceRange.minPrice)} - ${this.convertPriceToString(priceRange.maxPrice)}`
    } else {
      if (priceRange.minPrice) {
        priceString = this.convertPriceToString(priceRange.minPrice)
      }
    }
    return priceString
  }

  convertPriceToString (price: Price): string {
    let priceString = ''
    if (price.formattedValue) {
      priceString = price.formattedValue
    } else {
      priceString = this.currencyPipe.transform(price.value, price.currencyIso || 'USD') || ''
    }
    return priceString
  }

  existAndHasValues<T> (value: T | undefined): value is T {
    return !!value && Object.keys(value).length > 0
  }
}
